import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import {
    LIGHT_OF_HISTORY_CATALOG_CONFIG,
    LIGHT_OF_HISTORY_CATALOG_TYPE,
    LightOfHistorySelectedItems,
} from './InstancesCatalogLightOfHistory-types'

const InstancesCatalogLightOfHistoryComponent = () => {
    const [selectedItems, setSelectedItems] = useState<LightOfHistorySelectedItems>([])

    return (
        <Content title={LIGHT_OF_HISTORY_CATALOG_TYPE}>
            <Catalog
                type={LIGHT_OF_HISTORY_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                treeView={LIGHT_OF_HISTORY_CATALOG_CONFIG.treeView}
                additionalData={LIGHT_OF_HISTORY_CATALOG_CONFIG.additionalData}
                fixedHeader={LIGHT_OF_HISTORY_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={LIGHT_OF_HISTORY_CATALOG_CONFIG.isExistRightToolbar}
                hideHeader={LIGHT_OF_HISTORY_CATALOG_CONFIG.hideHeader}
                handleSortable={LIGHT_OF_HISTORY_CATALOG_CONFIG.handleSortable}
            />
        </Content>
    )
}

export const InstancesCatalogLightOfHistory = checkAvailableModule('instancesCatalog/lightOfHistory')
    ? InstancesCatalogLightOfHistoryComponent
    : null
